import React from "react";
import Menu from "../../../../components/Menu";
import Loading from "../../../../components/Loading";
import before from "../../../../assets/vw/svg/before-mon-azul.svg";
import cerrar from "../../../../assets/vw/svg/cerrar.svg";
import { withRouter } from "react-router-dom";
import Modal from "../../../../components/Modal";
import { buildEstado } from "../../../../utils/estadoCodeBuild";
import WARNING from "../../../../assets/vw/svg/warning-icon.svg"
import download_icon from "../../../../assets/vw/svg/download.svg";

class Monitoreo extends React.Component {
  constructor(props) {
    super(props);

    const urlParams = new URLSearchParams(window.location.search);

    this.state = {
      aplicacion: null,
      cargando: true,
      editable: false,
      editando: false,
      codigo: "",
      idApp: urlParams.get('ia'),
      codigoValido: false,
      showModal: false,
      urls:[],
      estado: "Sin monitorear",
      messageError:[],
      messageModal: "",
      modal: {
        active: false,
        message: '',
        success: false
      },
    };
  }
  componentDidMount() {
    this.fetchData();
  }
  fetchData() {
    fetch(`${process.env.REACT_APP_URL_DTO_BACK}aplicacion/monitoreo?ia=${this.state.idApp}`, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + this.props.servicio.getToken(),
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        if (!res.ok) {
          throw new Error("Error al obtener los datos.");
        }
        let responseBody = await res.json();
        this.setState({aplicacion: responseBody.mensaje[0],codigo: responseBody.mensaje[0].codigo});
        await Promise.all(responseBody.mensaje.map(async (aplicacion) => {
          let monitoreo = await this.props.onObtenerEstado(aplicacion.codigo);
          aplicacion.estado = monitoreo.Estado;
          aplicacion.urls = monitoreo.urls;
          aplicacion.messageError = monitoreo.messageError;
        }));
        this.setState({
          cargando: false,
          urls: responseBody.mensaje[0].urls,
          estado: responseBody.mensaje[0].estado
        });
        if (responseBody.mensaje[0].messageError.length > 0){
          this.setState({
            messageError: responseBody.mensaje[0].messageError,
          });
        }
      })
      .catch((errorP) => {
        console.error("Error en la petición:", errorP.stack || errorP);
        this.setState({ cargando: false, modal: {
          active: true,
          message: errorP.message || errorP,
          success: false
        }});
      });
  }
  handleEdit = () => {
    this.setState({
      editable: true,
      editando: true,
    });
  };
  handleCancel = () => {
    this.setState({
      editando: false,
      editable: false,
    });
  };
  handleSave = async (nombre) => {
    try {
      this.setState({
        cargando: true,
      });
      let res = await fetch(process.env.REACT_APP_URL_DTO_BACK + `aplicacion/monitoreo`, {
        method: "PUT",
        headers: {
          Authorization: "Bearer " + this.props.servicio.getToken(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          idApp: this.state.idApp,
          nombre: nombre || this.state.aplicacion.monitoreo,
          codigo: this.state.codigo,
        }),
      });
      if (!res.ok) {
        throw new Error("Error al guardar los cambios.");
      }
      this.fetchData();
      this.setState({
        editando: false,
        editable: false,
        cargando: false,
      });
      this.toggleModal();
    } catch (error) {
      console.error("Error en la petición:", error.stack || error);
      this.setState({
        editando: false,
        editable: false,
        cargando: false,
      });
      this.setState({ cargando: false, modal: {
        active: true,
        message: error.message || error,
        success: false
      }});
    }
  };
  handleDownload = async () => {
    window.open(this.state.aplicacion.build.logs, '_blank');
  };
  handleChange = (event) => {
    this.setState({
      codigo: event.target.value,
      codigoValido: event.target.value.trim() !== "",
    });
  };
  toggleModal = (tipo) => {
    this.setState(prevState => ({
      showModal: !prevState.showModal,
    }));
  };
  handleClick = () => {
    const { history } = this.props;
    this.toggleModal();
    history.push('/vw/especialista/monitoreos');
  };
  
  
  render() {
    const { aplicacion, cargando, editable, editando, codigo, showModal,urls, estado, messageError } = this.state;
    if (cargando) {
      return <Loading />;
    }
    
    return (
      <>
        <Menu />
        <Modal 
          modalInfo={this.state.modal} 
          setMostrarModal={(data) => {
            this.setState({ modal: data });
          }} 
        />
        {
          this.state.cargando && <Loading />
        }
        <div className="navegacion monitoreo">
          <a href="/vw/especialista/monitoreos" className="returnToMon">
            <img src={before} alt="before" />
            Regresar
          </a>
          {(aplicacion && aplicacion.codigo) && (
            <>
              <div className="title_monitoring_app">
                <div className={`dot dot--${estado.trim().toLowerCase()}`}></div>
                {aplicacion.nombre}
              </div>
              <div className="row container-monitoring-configuration">
                <div className="col-md-4">
                  <div className="container-link">
                    <div className="title_monitoring_id">
                      ID app: {aplicacion.idApp}
                    </div>
                    <div className="link-app">
                      <ol>
                        <div className="title_link pb-1">Enlace</div>
                        {urls.map((url, index) => {
                        const error = messageError.find(error => error.startsWith(`${index} - `));
                        const mensaje = error ? error.split(' - ')[1] : '';
                        const status = mensaje ? 'error' : 'success';
                        return (
                        <div className="url-container" key={index}>
                            <li>
                            <div className="link">
                                  <div className="url">{url}</div>
                                  <div className={status}></div>
                                </div>
                                { mensaje !== '' &&
                                  <div className="message-error">{mensaje}</div>
                                }
                            </li>
                          </div>
                        );
                        })}
                      </ol>
                    </div>
                  </div>
                  <div className="container-build d-flex flex-md-row flex-column">
                    <div className="estado-app px-0 py-1 pl-md-1">
                      <div className="pb-1">Estado de la publicación</div>
                      <div className="estado">
                        <div className="title">
                          <img src={buildEstado(aplicacion.build?.status)} alt="build" width={20}/>
                          <div className="title_monitoring_id">
                            {aplicacion.build ? aplicacion.build.status : "Sin datos de compilación"}
                          </div>
                        </div>
                        {aplicacion.build && (
                          <div className="body">
                            <div className="subtitle">
                              <span>Datos de la Compilación:</span>
                            </div>
                            <div className="detail">
                              <span className="detail-title">Nombre del proyecto en code build:</span>
                              <span>{aplicacion.build.nameProject}</span>
                            </div>
                            <div className="detail">
                              <span className="detail-title">Fecha de creación:</span>
                              <span>
                                {aplicacion.build?.inicia 
                                  ? new Date(aplicacion.build.inicia).toLocaleDateString('es-ES', { 
                                    day: '2-digit', 
                                    month: '2-digit', 
                                    year: 'numeric', 
                                    hour: '2-digit', 
                                    minute: '2-digit', 
                                    second: '2-digit' 
                                    }) 
                                  : "Fecha no disponible"
                                }
                              </span>
                            </div>
                            <div className="detail">
                              <span className="detail-title">Fecha de última actualización:</span>
                              <span>
                                {aplicacion.build?.termina 
                                  ? new Date(aplicacion.build.termina).toLocaleDateString('es-ES', { 
                                    day: '2-digit', 
                                    month: '2-digit', 
                                    year: 'numeric', 
                                    hour: '2-digit', 
                                    minute: '2-digit', 
                                    second: '2-digit' 
                                    }) 
                                  : "Fecha no disponible"
                                }
                              </span>
                            </div>
                            <div className="detail">
                              <span className="detail-title">Fase:</span>
                              <span>{aplicacion.build.faseActual}</span>
                            </div>
                          </div>
                        )}
                      </div>
                      {aplicacion?.build?.faseActual === "COMPLETED" && aplicacion?.build?.logs && (
                        <div className="mt-2">
                          <button
                            type="submit"
                            className="button_vw button_vw--descarga w-auto d-flex align-items-center justify-content-center px-4"
                            onClick={this.handleDownload}
                          >
                            <img src={download_icon} alt="download" className="icono-download"/>
                            <span className={"ml-2"}>Descargar Log</span>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="container-code">
                    <div className="title_code">Código de monitoreo</div>
                    <div className="btn_actions_edit">
                      {!editando && (
                        <>
                          <button className="edit-icon" onClick={this.handleEdit}></button>
                        </>
                      )}
                    </div>
                    <textarea
                      value={codigo}
                      onChange={this.handleChange}
                      className={editable ? "" : "disabled"}
                      disabled={!editable}
                      rows={10}
                      cols={50}
                    />
                    <div className="btn_actions">
                      {editando && (
                        <>
                          <button
                            className="button_vw button_vw--secondary order-2 order-sm-1"
                            onClick={this.handleCancel}
                          >
                            Cancelar
                          </button>
                          <button
                            className="button_vw button_vw--primary order-1 order-sm-2"
                            onClick={() => {
                              this.handleSave();
                            }}
                            disabled={!this.state.codigoValido}
                          >
                            Guardar
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          {(aplicacion && !aplicacion.codigo) && (
            <>
              <div className="title_monitoring_app">
                <div className="dot"></div>
                {aplicacion.nombre}
              </div>
              <div className="row container-monitoring-configuration">
                <div className="col-md-4 container-monitoring">
                  <div className="container-link">
                    <div className="title_monitoring_id">
                      ID app: {aplicacion.idApp}
                    </div>
                    <div className="link-app">
                      <div className="title_link pb-1">Enlace</div>
                      <div className="d-flex flex-row gap-1 pb-1">
                        <div className="edit-icon"></div>
                        <div className="col py-1 link">
                          <div>{aplicacion.url}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="container-build d-flex flex-md-row flex-column">
                    <div className="estado-app px-0 py-1 pl-md-1">
                      <div className="pb-1">Estado de la publicación</div>
                        <div className="estado">
                          <div className="title">
                            <img src={buildEstado(aplicacion.build?.status)} alt="build" width={20}/>
                            <div className="title_monitoring_id">
                              {aplicacion.build ? aplicacion.build.status : "Sin datos de compilación"}
                            </div>
                          </div>
                          {aplicacion.build && (
                            <div className="body">
                              <div className="subtitle">
                                <span>Datos de la Compilación:</span>
                              </div>
                              <div className="detail">
                                <span className="detail-title">Nombre del proyecto en code build:</span>
                                <span>{aplicacion.build.nameProject}</span>
                              </div>
                              <div className="detail">
                                <span className="detail-title">Fecha de creación:</span>
                                <span>
                                  {aplicacion.build?.inicia 
                                    ? new Date(aplicacion.build.inicia).toLocaleDateString('es-ES', { 
                                      day: '2-digit', 
                                      month: '2-digit', 
                                      year: 'numeric', 
                                      hour: '2-digit', 
                                      minute: '2-digit', 
                                      second: '2-digit' 
                                      }) 
                                    : "Fecha no disponible"
                                  }
                                </span>
                              </div>
                              <div className="detail">
                                <span className="detail-title">Fecha de última actualización:</span>
                                <span>
                                  {aplicacion.build?.termina 
                                    ? new Date(aplicacion.build.termina).toLocaleDateString('es-ES', { 
                                      day: '2-digit', 
                                      month: '2-digit', 
                                      year: 'numeric', 
                                      hour: '2-digit', 
                                      minute: '2-digit', 
                                      second: '2-digit' 
                                      }) 
                                    : "Fecha no disponible"
                                  }
                                </span>
                              </div>
                              <div className="detail">
                                <span className="detail-title">Fase:</span>
                                <span>{aplicacion.build.faseActual}</span>
                              </div>
                            </div>
                          )}
                      </div>
                      {aplicacion?.build?.faseActual === "COMPLETED" && aplicacion?.build?.logs && (
                        <div className="mt-2">
                          <button
                            type="submit"
                            className="button_vw button_vw--descarga w-auto d-flex align-items-center justify-content-center px-4"
                            onClick={this.handleDownload}
                            data-track-click="btn-descarga-log"
                          >
                            <img src={download_icon} alt="download" className="icono-download"/>
                            <span className={"ml-2"}>Descargar Log</span>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="container-code">
                    <div className="title_code">Código de monitoreo</div>
                    <textarea
                      value={codigo}
                      onChange={this.handleChange}
                      disabled={false}
                      rows={10}
                      cols={50}
                    />
                    <div className="btn_actions">
                      <button
                        className="button_vw button_vw--secondary order-2 order-sm-1"
                        onClick={this.handleCancel}
                      >
                        Cancelar
                      </button>
                      <button
                        className="button_vw button_vw--primary order-1 order-sm-2"
                        onClick={() => {
                          this.handleSave(`${aplicacion.nombre}.txt`);
                        }}
                        disabled={!this.state.codigoValido}
                      >
                        Guardar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          {showModal && (
            <div className="modal-success">
              <div className="modal-content-success">
                <span className="modal-close" onClick={this.toggleModal}>
                  <img src={cerrar} alt="Close" />
                </span>
                <h2>¡Listo!</h2>
                <p>El código ha sido guardado exitosamente.</p>
                <div className="modal-buttons">
                  <button 
                    className="button_vw button_vw--primary-mon order-1 order-sm-2" 
                    onClick={() => {
                      this.toggleModal();
                      this.handleClick();
                    }}
                  >
                    Ir al dashboard
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
}
export default withRouter(Monitoreo);
